import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

import { CatalogOperator } from "@/pages/configuration/models/CatalogOperator";

type Props = {
	setSelectedRowData: (operator: CatalogOperator) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	handleNewOperator: () => void;
	editOperator: (data: CatalogOperator) => void;
};
export const useOperatorOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
	handleNewOperator,
	editOperator,
}: Props) => {
	const getMenuOptions = (data: CatalogOperator) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Operator",
				key: "new_operator",
				onClick: () => {
					handleNewOperator();
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Operator",
					key: "edit_operator",
					onClick: () => {
						editOperator(data);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Operator",
					key: "delete_operator",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("delete");
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
